import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import { useSelector, useDispatch } from 'react-redux';
import validator from 'validator';
import clsx from 'clsx';
import ButtonMain from '../../components/common/ButtonMain';
import SuccessPopup from '../../components/common/SuccessPopup';
import FailurePopup from '../../components/common/FailurePopup';
import { userRegistrationAPI } from '../../store/features/userRegistration';
import PasswordField from '../../components/common/passwordInput';

function SignUpPassword(props) {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  const {
    setSelectedState, sliderState, setSliderState, SliderRegistration, email, fullName, onBack
  } = props;

  const [stateName, setStateMethod] = useState({
    firstPassword: '',
    firstPasswordInvalidError: false,
    firstPasswordInvalid: '',
    secondPassword: '',
    secondPasswordInvalidError: '',
    secondPasswordInvalid: false,
    FormSubmitting: false,
    firstPasswordState: false,
    secondPasswordState: false,
    showPassword: false,
  });

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showOkayButton, setShowOkayButton] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  };
  const onCloseFailurePopup = () => {
    setShowFailurePopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  };
  const ValidatePassword = (password) => {
    if (
      validator.isStrongPassword(password, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      return true;
    }
    return false;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setStateMethod((prev) => {
      let updated = { ...prev, [name]: value };

      // Clear error if field is empty
      if (!value.trim()) {
        if (name === "firstPassword") {
          updated.firstPasswordInvalidError = "";
          updated.firstPasswordInvalid = false;
          updated.firstPasswordState = false;
        }
        if (name === "secondPassword") {
          updated.secondPasswordInvalidError = "";
          updated.secondPasswordInvalid = false;
          updated.secondPasswordState = false;
        }
        return updated;
      }

      // If user is fixing first password error → revalidate live
      if (name === "firstPassword" && prev.firstPasswordInvalid) {
        if (!ValidatePassword(value)) {
          updated.firstPasswordInvalidError = t.PASSWORDERROR;
          updated.firstPasswordInvalid = true;
          updated.firstPasswordState = false;
        } else {
          updated.firstPasswordInvalidError = "";
          updated.firstPasswordInvalid = false;
          updated.firstPasswordState = true;
        }
      }

      // If user is fixing confirm password error → revalidate live
      if (name === "secondPassword" && prev.secondPasswordInvalid) {
        if (value !== prev.firstPassword) {
          updated.secondPasswordInvalidError = t.CONFIRMPASSWORDERROR;
          updated.secondPasswordInvalid = true;
          updated.secondPasswordState = false;
        } else {
          updated.secondPasswordInvalidError = "";
          updated.secondPasswordInvalid = false;
          updated.secondPasswordState = true;
        }
      }

      return updated;
    });
  };


  const EnableHandler = () => {
    let updated = { ...stateName };
    let valid = true;

    // Validate first password
    if (!ValidatePassword(stateName.firstPassword)) {
      updated.firstPasswordInvalidError = t.PASSWORDERROR;
      updated.firstPasswordInvalid = true;
      updated.firstPasswordState = false;
      valid = false;
    }

    // Validate confirm password
    if (stateName.firstPassword !== stateName.secondPassword) {
      updated.secondPasswordInvalidError = t.CONFIRMPASSWORDERROR;
      updated.secondPasswordInvalid = true;
      updated.secondPasswordState = false;
      valid = false;
    }

    setStateMethod(updated);

    if (!valid) return;

    // If valid → submit
    setIsLoading(true);
    const userRegistrationDispatcher = dispatch(userRegistrationAPI({
      email,
      fullName,
      password: stateName.firstPassword,
    }));

    userRegistrationDispatcher
      .then((data) => {
        if (data.payload.success === true) {
          setIsLoading(false);
          setSelectedState(2);
        }
      })
      .catch((error) => {
        setAlertMessage(error.message);
        setShowFailurePopup(true);
        setIsLoading(false);
      });
  };


  useEffect(() => {
    return () => {
      setStateMethod({
        ...stateName,
        firstPassword: '',
        secondPassword: '',
        firstPasswordState: false,
        secondPasswordState: false,
        firstPasswordInvalid: false,
        secondPasswordInvalid: false,
        firstPasswordInvalidError: '',
        secondPasswordInvalidError: ''
      });
    };
  }, []);

  return (
    <div className="SignUp-main-container">
      {/* Popups */}
      <SuccessPopup
        show={showSuccessPopup}
        description={alertMessage}
        showOkayButton={showOkayButton}
        showCancelButton={showCancelButton}
        onOkay={onCloseSuccessPopup}
      />
      <FailurePopup
        show={showFailurePopup}
        description={alertMessage}
        showOkayButton={showOkayButton}
        showCancelButton={showCancelButton}
        onOkay={onCloseFailurePopup}
      />
      {/* Popups */}
      <div className="slider-signup">
        <div className="inputDivStyle-signup">
          {/* Step indicator - appears twice, consider if this is intentional */}
          <p style={{ position: 'relative', top: '25px' }} className="step__123">
            {`${t.STEP} 1`}
          </p>
          <p className="step__left">
            {`${t.STEP} 2`}
          </p>

          {/* Stepper progress bar */}
          <div className="stepper__123">
            {SliderRegistration.map((stateValue, index) => (
              <p
                key={index}
                className={clsx(
                  'underline__1',
                  {
                    'underline__1_completed': sliderState > stateValue, // green for completed steps
                    'underline__1_active': sliderState === stateValue    // highlight for current step
                  },



                )}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="inputDivStyle-signup">
        <div className="textDiv">
          <p className="text__create">{t.CREATE_PASSWD}</p>
          <p className="text__start">{t.FREE_TRIAL}</p>
        </div>
        <div>
          <PasswordField
            name="firstPassword"
            id="firstPassword"
            type="Password"
            title={t.ENTR_PWD}
            placeholder={t.ENTR_PASS_PH}
            value={stateName.firstPassword}
            onChange={(e) => handleChange(e)}
            error={stateName.firstPasswordInvalidError}
            className={clsx(
              stateName.firstPasswordInvalid ? 'input__error' : '',
              stateName.firstPasswordState ? 'input__success' : '',
            )}
          />
          <br />
          <PasswordField
            name="secondPassword"
            id="secondPassword"
            type="password"
            title={t.ENTR_PWD_C}
            placeholder={t.REENTR_PASS_PH}
            value={stateName.secondPassword}
            onChange={(e) => handleChange(e)}
            error={stateName.secondPasswordInvalidError}
            className={clsx(
              stateName.secondPasswordInvalid ? 'input__error' : ' ',
              stateName.secondPasswordState ? 'input__success' : ' ',
            )}
          />
        </div>
        <div className="btn-class">
          <ButtonMain
            title={isLoading ? t.BTN_LOADING : t.BTN_CONTINUE}
            className={
              stateName.firstPassword?.trim() && stateName.secondPassword?.trim() && !isLoading
                ? 'buttonStyleEnable'
                : 'buttonStyleDisabled'
            }
            disabled={!(stateName.firstPassword?.trim() && stateName.secondPassword?.trim()) || isLoading}
            onClick={() => EnableHandler()}
          />
          <ButtonMain
            title={t.BTN_BACK}
            onClick={() => {
              if (!isLoading) {
                onBack();
              }
            }}
            className="btn__back"

          />
        </div>
      </div>
    </div>
  );
}
SignUpPassword.propTypes = {
  setSelectedState: PropTypes.func.isRequired,
  sliderState: PropTypes.number.isRequired,
  setSliderState: PropTypes.func.isRequired,
  SliderRegistration: PropTypes.arrayOf(
    PropTypes.shape({
    }),
  ).isRequired,
  email: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default SignUpPassword;
